import React from 'react';
import { DNABox, DNAButton, DNAIcon, DNAText } from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';
import { format, parseISO } from 'date-fns';
import { useHistory } from 'src/router';
import WidgetContainer from 'src/screens/Home/Widgets/WidgetContainer';
import { useBulletins } from './useBulletins';

export const BulletinWidget: React.FC = () => {
  const { bulletins, name, hydrated, canRead } = useBulletins();
  const history = useHistory();
  const latest = bulletins[0];
  if (!canRead) return null;
  return (
    <WidgetContainer title={name}>
      <DNABox appearance="col" spacing="md" fill testID="bulletin-widget">
        {latest ? (
          <DNABox spacing="sm" alignY="start" childFill={1} childStyle={[1, { minWidth: 0 }]}>
            <DNABox
              alignX="center"
              alignY="center"
              style={{ width: 32, height: 32, borderRadius: 8, backgroundColor: colors['color-ui2-neutral-100'] }}
            >
              <DNAIcon.Styled name="newspaper" size="lg" color={colors['color-ui2-neutral-900']} />
            </DNABox>
            <DNABox appearance="col" spacing="xs" shrink style={{ minWidth: 0, maxWidth: '100%' }}>
              <DNAText bold numberOfLines={2} ellipsizeMode="tail">{latest.title}</DNAText>
              <DNAText status="tertiary">{format(parseISO(latest.publishedAt), 'MMMM d, yyyy')}</DNAText>
            </DNABox>
          </DNABox>
        ) : (
          <DNAText b1 status="tertiary" style={{ lineHeight: 21 }}>
            {hydrated
              ? 'No posts yet. Team updates, deadlines, and resources will show up here when they’re posted.'
              : 'Loading posts…'}
          </DNAText>
        )}
        <DNAButton appearance="outline" onPress={() => history.push('/bulletin')}>
          View
        </DNAButton>
      </DNABox>
    </WidgetContainer>
  );
};
